import { render, staticRenderFns } from "./UserAnnouncement.vue?vue&type=template&id=917ec53e&scoped=true"
import script from "./UserAnnouncement.vue?vue&type=script&lang=js"
export * from "./UserAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./UserAnnouncement.vue?vue&type=style&index=0&id=917ec53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917ec53e",
  null
  
)

export default component.exports